module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-152x152-0547c648713beb28407e9fdcb9e6906b.png";